(() => {
  'use strict';
  if (window.__fwAvail) return;
  window.__fwAvail = true;

  const VERSAND_ID = String(window.FW_VERSANDSHOP_ID || '95258968332');

  /* ---------- Standort ---------- */
  const getLocId = () => {
    if (window.FW_SELECTED_LOCATION_ID) return String(window.FW_SELECTED_LOCATION_ID);
    for (const key of ['fw_location', 'selected_location']) {
      let v = null;
      try { v = localStorage.getItem(key); } catch (e) {}
      if (!v) continue;
      try {
        const o = JSON.parse(v);
        if (o && typeof o === 'object') return String(o.id || o.locationId || '');
        return String(o);
      } catch (e) {
        return String(v);
      }
    }
    return null;
  };

  /* Standort wechseln: exakt wie Header-Drawer (inkl. Warenkorb-Attribute), ohne Reload */
  const switchLocation = (id) => {
    id = String(id);
    closeDrawer();
    if (typeof window.fwSelectLocation === 'function' && window.fwSelectLocation(id)) return;

    try {
      localStorage.setItem('fw_location', id);
      localStorage.setItem('selected_location', id);
    } catch (e) {}
    if (typeof window.multilocaHeaderEvent === 'function') {
      try { window.multilocaHeaderEvent(id); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('fw:location-change', { detail: { id } }));
  };

  const locs = () => (Array.isArray(window.FW_LOCATIONS) ? window.FW_LOCATIONS : []);
  const nameOf = (l) => (l && (l.company || l.label || l.name)) || '';
  const locName = (id) => {
    if (String(id) === VERSAND_ID) return 'Versandshop';
    return nameOf(locs().find((x) => String(x.id) === String(id)));
  };

  /* ---------- Konstanten ---------- */
  const DEF = { g: 20, b: 15, r: 5 };
  const STATUS = [
    ['fo-delivery-status--stock', 'stock'],
    ['fo-delivery-status--preorder', 'pre'],
    ['fo-delivery-status--soon', 'soon'],
    ['fo-delivery-status--soldout', 'none'],
    ['fo-delivery-status--none', 'none']
  ];
  const BADGE = { stock: 'Auf Lager', pre: 'Vorbestellbar', soon: 'Demnächst', none: 'Nicht verfügbar' };
  const FLAME = '<svg class="fw-av__flame" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 22a7 7 0 0 1-7-7c0-3.7 2.3-6.7 3-7.5.3 1.6 1.2 3 2.5 3.5 0-3 1.5-6.5 1.5-6.5s7 5 7 10.5a7 7 0 0 1-7 7Z"/></svg>';
  const PIN = '<svg class="fw-av-row__pin" viewBox="0 0 12 15" aria-hidden="true"><path fill="currentColor" d="M6 0C2.7 0 0 2.7 0 6c0 4.2 6 9 6 9s6-4.8 6-9c0-3.3-2.7-6-6-6Zm0 8.2A2.2 2.2 0 1 1 6 3.8a2.2 2.2 0 0 1 0 4.4Z"/></svg>';

  /* ---------- Stufenlogik ---------- */
  const th = (el) => {
    const g = +el.dataset.g, b = +el.dataset.b, r = +el.dataset.r;
    return g > b && b > r && r >= 1 ? { g, b, r } : DEF;
  };
  const level = (q, t) => (q <= 0 ? null : q >= t.g ? 'green' : q >= t.b ? 'blue' : q > t.r ? 'orange' : 'red');
  const word = (pre) => (pre ? 'vorbestellbar' : 'verfügbar');

  /* Wording: Grün = Viele, Blau = Gut, Orange = Wenige, Rot = Nur noch X Stück */
  const text = (q, lvl, pre) => {
    const w = word(pre);
    if (lvl === 'green') return 'Viele ' + w;
    if (lvl === 'blue') return 'Gut ' + w;
    if (lvl === 'orange') return 'Wenige ' + w;
    return 'Nur noch ' + q + ' Stück ' + w;
  };
  const pct = (q, t) => (Math.min(q, t.g) / t.g) * 100 + '%';
  const sellable = (st, q) => (st === 'stock' || st === 'pre') && q > 0;

  /* ---------- Daten ---------- */
  const parseInv = (raw) => {
    let d = raw;
    for (let i = 0; i < 2 && typeof d === 'string'; i++) {
      try { d = JSON.parse(d); } catch (e) { d = null; }
    }
    const m = {};
    ((d && d.invLoc) || []).forEach((x) => {
      if (x && x.loc) m[String(x.loc.id)] = Number(x.qty) || 0;
    });
    return m;
  };

  const findStatusEl = (el) => {
    let n = el.parentElement;
    while (n) {
      const s = n.querySelector('.fo-delivery-status');
      if (s) return s;
      n = n.parentElement;
    }
    return null;
  };
  const statusOf = (el) => {
    if (!el) return null;
    for (const [c, s] of STATUS) if (el.classList.contains(c)) return s;
    return null;
  };

  /* ---------- Countdown (auch für Deal-Banner nutzbar) ---------- */
  const pad = (n) => String(n).padStart(2, '0');
  window.FWCountdown = window.FWCountdown || {
    format(ms) {
      const s = Math.max(0, Math.floor(ms / 1000));
      if (s >= 86400) return Math.floor(s / 86400) + ' T ' + Math.floor((s % 86400) / 3600) + ' Std';
      return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    },
    urgent: (ms) => ms < 3600000
  };
  const dealEnd = (raw) => {
    if (!raw || raw.indexOf('|') < 0) return null;
    let d = raw.split('|')[1].trim();
    d = /^\d{4}-\d{2}-\d{2}$/.test(d) ? d + 'T23:59:59' : d.replace(' ', 'T');
    const t = Date.parse(d);
    return isNaN(t) ? null : t;
  };

  /* ---------- PDP / Quickview ---------- */
  const variantId = (root) => {
    const scope = root.closest('form, .product, [data-product], .quickview') || document;
    const input = scope.querySelector('[name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? String(input.value) : Object.keys(root._data || {})[0];
  };

  function renderPdp(root) {
    if (!root._data) {
      try { root._data = JSON.parse(root.querySelector('.fw-av__data').textContent || '{}'); }
      catch (e) { root._data = {}; }
      root._end = dealEnd(root.dataset.deal);
    }
    const locId = getLocId();
    const st = statusOf(findStatusEl(root));
    const t = th(root);
    const inv = parseInv(root._data[variantId(root)]);
    const q = locId ? inv[String(locId)] || 0 : 0;

    root._inv = inv;
    root._st = st;
    root._t = t;
    root.hidden = !locId || !st;
    if (root.hidden) return;

    root.querySelector('.fw-av__loc').textContent = locName(locId);
    const badge = root.querySelector('.fw-av-badge');
    badge.className = 'fw-av-badge fw-av-badge--' + st;
    badge.textContent = BADGE[st];

    const show = sellable(st, q);
    root._show = show;
    root.querySelector('.fw-av__barwrap').hidden = !show;

    if (show) {
      const lvl = level(q, t);
      root.dataset.level = lvl;
      root.querySelector('.fw-av__fill').style.width = pct(q, t);
      const label = root.querySelector('.fw-av__label');
      label.innerHTML = (lvl === 'red' ? FLAME : '') + '<span class="fw-av__text"></span>';
      label.lastChild.textContent = text(q, lvl, st === 'pre');
    } else {
      delete root.dataset.level;
    }
    tick(root);

    const dr = document.getElementById('fw-av-drawer');
    if (dr && !dr.hidden && dr._root === root) renderDrawer(root);
  }

  function tick(root) {
    const cd = root.querySelector('.fw-av__cd');
    if (!cd) return;
    const ms = root._end ? root._end - Date.now() : 0;
    const on = !!root._show && ms > 0;
    cd.hidden = !on;
    if (!on) return;
    cd.classList.toggle('is-urgent', window.FWCountdown.urgent(ms));
    cd.querySelector('.fw-av__cdt').textContent = 'Deal endet in ' + window.FWCountdown.format(ms);
  }

  /* ---------- Drawer ---------- */
  function drawerEl() {
    let d = document.getElementById('fw-av-drawer');
    if (d) return d;
    d = document.createElement('div');
    d.id = 'fw-av-drawer';
    d.className = 'fw-av-drawer';
    d.setAttribute('data-fw-own', '');
    d.hidden = true;
    d.innerHTML =
      '<div class="fw-av-drawer__overlay" data-close></div>' +
      '<aside class="fw-av-drawer__panel" role="dialog" aria-modal="true" aria-label="Verfügbarkeiten an Standorten">' +
      '<div class="fw-av-drawer__top"><strong>Verfügbarkeiten an Standorten</strong>' +
      '<button type="button" class="fw-av-drawer__x" data-close aria-label="Schließen">&times;</button></div>' +
      '<div class="fw-av-drawer__product"></div>' +
      '<p class="fw-av-drawer__hint">Tippe auf einen Shop, um deinen Standort zu wählen.</p>' +
      '<ul class="fw-av-drawer__list"></ul></aside>';
    d.addEventListener('click', (e) => {
      if (e.target.closest('[data-close]')) return closeDrawer();
      const btn = e.target.closest('[data-loc-id]');
      if (btn && !btn.classList.contains('is-current')) switchLocation(btn.dataset.locId);
    });
    document.body.appendChild(d);
    return d;
  }

  function groupHead(label) {
    const li = document.createElement('li');
    li.setAttribute('aria-hidden', 'true');
    li.style.cssText = 'border:0;padding:16px 10px 4px;font-size:10.5px;font-weight:700;color:#9a9891;text-transform:uppercase;letter-spacing:.07em';
    li.textContent = label;
    return li;
  }

  function row(id, name, q, st, t, cur) {
    const li = document.createElement('li');
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fw-av-row' + (cur ? ' is-current' : '');
    btn.dataset.locId = id;
    btn.title = cur ? name + ' (dein Standort)' : name + ' als Standort wählen';
    if (cur) btn.setAttribute('aria-current', 'true');

    const n = document.createElement('span');
    n.className = 'fw-av-row__name';
    n.innerHTML = cur ? PIN : '';
    const nt = document.createElement('span');
    nt.textContent = name;
    n.appendChild(nt);
    btn.appendChild(n);

    const status = document.createElement('span');
    status.className = 'fw-av-row__status';

    if (sellable(st, q)) {
      const lvl = level(q, t);
      btn.dataset.level = lvl;
      btn.insertAdjacentHTML('beforeend', '<span class="fw-av__bar"><span class="fw-av__fill" style="width:' + pct(q, t) + '"></span></span>');
      status.innerHTML = lvl === 'red' ? FLAME : '';
      status.appendChild(document.createTextNode(text(q, lvl, st === 'pre')));
    } else {
      btn.insertAdjacentHTML('beforeend', '<span class="fw-av-row__bar-empty"></span>');
      const key = st === 'soon' ? 'soon' : 'none';
      const b = document.createElement('span');
      b.className = 'fw-av-badge fw-av-badge--' + key;
      b.textContent = BADGE[key];
      status.appendChild(b);
    }
    btn.appendChild(status);
    li.appendChild(btn);
    return li;
  }

  function renderDrawer(root) {
    const d = drawerEl();
    d._root = root;

    const p = d.querySelector('.fw-av-drawer__product');
    p.innerHTML = '';
    if (root.dataset.img) {
      const img = new Image();
      img.src = root.dataset.img;
      img.alt = '';
      img.width = 56;
      img.height = 56;
      p.appendChild(img);
    }
    const title = document.createElement('span');
    title.textContent = root.dataset.title || '';
    p.appendChild(title);

    const list = d.querySelector('.fw-av-drawer__list');
    list.innerHTML = '';
    const cur = String(getLocId() || '');
    const pre = root.dataset.pre === '1' || root._st === 'pre';
    const t = root._t || DEF;

    const statusFor = (id, q) => {
      if (id === cur) return root._st;
      if (root._st === 'soon') return 'soon';
      return q > 0 ? (pre ? 'pre' : 'stock') : 'none';
    };
    const add = (id, name) => {
      const q = (root._inv && root._inv[id]) || 0;
      list.appendChild(row(id, name, q, statusFor(id, q), t, id === cur));
    };

    /* Nach Hause: Versandshop */
    list.appendChild(groupHead('Nach Hause'));
    add(VERSAND_ID, 'Versandshop');

    /* Abholung: gewählter Standort zuerst, dann alle anderen */
    list.appendChild(groupHead('Abholung'));
    locs()
      .filter((l) => String(l.id) !== VERSAND_ID)
      .sort((a, b) => (String(b.id) === cur) - (String(a.id) === cur))
      .forEach((l) => add(String(l.id), nameOf(l)));
  }

  function openDrawer(root) {
    if (!root) return;
    renderDrawer(root);
    const d = drawerEl();
    d.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    d.querySelector('.fw-av-drawer__x').focus();
  }

  function closeDrawer() {
    const d = document.getElementById('fw-av-drawer');
    if (!d || d.hidden) return;
    d.hidden = true;
    document.documentElement.style.overflow = '';
  }

  /* ---------- Quickview / Karten: nur rote Stufe ---------- */
  function renderCard(el) {
    const locId = getLocId();
    const st = statusOf(findStatusEl(el));
    const t = th(el);
    const q = locId ? parseInv(el.dataset.inv)[String(locId)] || 0 : 0;
    const on = sellable(st, q) && level(q, t) === 'red';
    el.hidden = !on;
    if (!on) return;
    el.dataset.level = 'red';
    el.innerHTML = FLAME + '<span></span>';
    el.lastChild.textContent = 'Nur noch ' + q + ' ' + word(st === 'pre');
  }

  /* ---------- Steuerung ---------- */
  const renderAll = () => {
    document.querySelectorAll('[data-fw-avail]').forEach(renderPdp);
    document.querySelectorAll('[data-fw-avail-card]').forEach(renderCard);
  };

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; renderAll(); });
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.fw-av__open');
    if (btn) openDrawer(btn.closest('[data-fw-avail]'));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
  document.addEventListener('change', (e) => { if (e.target.matches('[name="id"]')) schedule(); });
  document.addEventListener('fw:location-change', schedule);
  document.addEventListener('locationChanged', schedule);
  window.addEventListener('storage', (e) => {
    if (e.key === 'fw_location' || e.key === 'selected_location') schedule();
  });

  new MutationObserver((list) => {
    if (list.some((m) => !(m.target.closest && m.target.closest('[data-fw-own]')))) schedule();
  }).observe(document.body, { childList: true, subtree: true });

  setInterval(() => {
    document.querySelectorAll('[data-fw-avail]').forEach((r) => { if (!r.hidden) tick(r); });
  }, 1000);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderAll);
  else renderAll();
})();